module.exports = __webpack_public_path__ + "static/media/rough-example-1.13a15862.png";